import Dot from '../src/Dot/index.tsx';
export default Dot;
